import { useEffect } from 'react';
import { useNavigate } from 'react-router-dom';

/**
 * Hook pour gérer les raccourcis clavier globaux
 * CTRL + ALT + A : Aller à Admin
 * CTRL + ALT + C : Ouvrir Croissants
 * CTRL + ALT + H : Retourner à la Home
 * CTRL + ALT + M : Aller à Edit Interface
 */
export const useGlobalKeyboardShortcuts = () => {
    const navigate = useNavigate();

    useEffect(() => {
        const onKeyDown = (e) => {
            // Ne pas interférer avec la saisie utilisateur
            const target = e.target;
            const isTyping = target && (
                target.tagName === 'INPUT' || 
                target.tagName === 'TEXTAREA' || 
                target.isContentEditable
            );
            if (isTyping) return;

            const isCtrlOrCmd = e.ctrlKey || e.metaKey;
            if (!isCtrlOrCmd || !e.altKey) return;

            const code = e.code; // position physique (ex: 'KeyC')
            const key = (e.key || '').toLowerCase(); // caractère saisi (ex: 'c')

            // Croissants: Ctrl/Cmd + Alt + C
            if (code === 'KeyC' || key === 'c') {
                e.preventDefault();
                window.open('https://croissants.altitudeinfra.fr/', '_blank', 'noopener,noreferrer');
                return;
            }

            // Admin: Ctrl/Cmd + Alt + A (AZERTY peut envoyer KeyQ pour la touche 'A')
            if (code === 'KeyA' || code === 'KeyQ' || key === 'a') {
                e.preventDefault();
                navigate('/admin/dashboard/analytics');
                return;
            }

            // Home: Ctrl/Cmd + Alt + H
            if (code === 'KeyH' || key === 'h') {
                e.preventDefault();
                navigate('/');
                return;
            }

            // Edit: Ctrl/Cmd + Alt + M
            if (code === 'KeyM' || key === 'm') {
                e.preventDefault();
                navigate('/edit-interface');
                return;
            }
        };

        window.addEventListener('keydown', onKeyDown);
        return () => window.removeEventListener('keydown', onKeyDown);
    }, [navigate]);
};
